/**
 * An object containing properties for a filterable field, used to select categories of filters
 */
var FilterField = /** @class */ (function () {
    function FilterField() {
    }
    return FilterField;
}());
export { FilterField };
//# sourceMappingURL=filter-field.js.map